import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Personal = () => {
  useEffect(() => {
    AOS.refresh();
  });

  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 200,
    });
  }, []);

  return (
    <>
      <div className="specific-container">
        <div class="debt-consolidation-section">
          <div class="debt-consolidation-left">
            <h1 class="section-title highlight-gradient">BUSINESS</h1>
            <p class="section-description ">
              Are you a business owner seeking funding to expand? A private loan
              can offer the financial support you need to elevate your business.
              Strengthen working capital, increase inventory, fund equipment
              purchases, upgrades, and expansion—gain access to the liquidity
              your business needs.
            </p>
            <p class="section-description">
              Don't let limited funds hold your business back. Apply for a
              private loan today and give your business the capital it needs.
            </p>
          </div>

          <div class="debt-consolidation-right">
            <div class="feature-point">
              <h2 class="feature-title">Fast and easy access to funds</h2>
              <p class="feature-text">
                Sometimes, timing is everything. With a private loan, you can
                access the funds you need quickly and easily, without the hassle
                and delays of traditional bank loans.
              </p>
            </div>

            <div class="feature-point">
              <h2 class="feature-title">Flexible lending criteria</h2>
              <p class="feature-text">
                Whether you're just starting out or ready to grow, apply now to
                explore our flexible lending criteria designed specifically for
                small businesses. Qualifying has never been easier.
              </p>
            </div>
          </div>
        </div>
        <div class="debt-consolidation-section">
          <div class="debt-consolidation-left">
            <h1 class="section-title highlight-gradient">
              MEDICAL / EMERGENCIES
            </h1>
            <p class="section-description ">
              The harsh reality of a medical emergency is that it can happen at
              any time, regardless of your financial preparedness. In some
              cases, a private loan may be the best solution for your needs. A
              private secured loan can provide quick funding for your expenses
              without requiring income or credit checks, allowing you to focus
              on what truly matters.
            </p>
          </div>
          <div class="debt-consolidation-right">
            <div class="feature-point">
              <h2 class="feature-title">Flexibility</h2>
              <p class="feature-text">
                We connect you with lenders offering a range of loan options and
                terms, giving you the flexibility to customize your loan to suit
                your unique needs and budget.
              </p>
            </div>

            <div class="feature-point">
              <h2 class="feature-title">Faster approval</h2>
              <p class="feature-text">
                With 24-hour approval, you can access your capital faster than
                through a traditional bank loan, even on short notice.
              </p>
            </div>
            <div class="feature-point">
              <h2 class="feature-title">No income or credit check</h2>
              <p class="feature-text">
                Get connected with lenders who don't require income or credit
                checks, making it easier for you to secure the funding you need.
              </p>
            </div>
          </div>
        </div>
        <div class="debt-consolidation-section">
          <div class="debt-consolidation-left">
            <h1 class="section-title highlight-gradient">LEGAL</h1>
            <p class="section-description ">
              Many Canadians often find themselves stressed over the burden of
              legal fees and outcomes. We're here to help, so you can focus on
              what matters most.
            </p>
            <p class="section-description">
              If you're feeling overwhelmed by the costs of hiring a lawyer, a
              private loan could be the solution to secure the effective legal
              representation you need.
            </p>
            <p class="section-description">
              Access the funds you need to hire the legal team that's best
              suited for your case. Don't let financial constraints prevent you
              from getting the representation you deserve. Take control of your
              legal situation today and find out if a private loan is the right
              option for you.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Personal;
